import { VFC, memo } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputContainerSelectBox: {
      marginLeft: 10,
      marginRight: 13,
      width: '100%'
    },
    selectBoxStyle: {
      WebkitAppearance: 'menulist-button',
      backgroundColor: 'white',
      borderColor: '#c1c1c1',
      minHeight: 48,
      width: '100%'
    },
    inputMainContainer: {
      display: 'flex',
      backgroundColor: '#F5F5F5',
      minHeight: 60,
      alignItems: 'center',
      width: '100%'
    }
  })
);

type Props = {
  editContent: boolean;
  data: any;
  id: number;
  onChange: (value: number) => void;
};

const PrimarySelect: VFC<Props> = props => {
  const { editContent, data, id, onChange } = props;
  const classes = useStyles();

  return (
    <div className={classes.inputMainContainer}>
      {editContent ? (
        <div style={{ paddingLeft: 10 }}>
          {data.find((type: any) => type.id === id).name}
        </div>
      ) : (
        <div className={classes.inputContainerSelectBox}>
          <select
            value={id}
            onChange={e => onChange(Number(e.target.value))}
            className={classes.selectBoxStyle}
            name='cars'
            id='cars'
            form='carform'
          >
            {data !== null &&
              data.map((i: any) => <option value={i.id}>{i.name}</option>)}
          </select>
        </div>
      )}
    </div>
  );
};

export default memo(PrimarySelect);
